import { memo } from "react";

import { ListItemWrapper } from "common/components/lists/ListItemWrapper";
import type { ListItemType } from "common/components/lists/types";
import type { TrackPage } from "domains/analytics/types";
import { KnowledgeDataNavigationItemBrowseView } from "domains/knowledgeData/components/KnowledgeDataNavigationItemBrowseView";
import { ArticleItem } from "domains/publication/components/ArticleItem";
import type { Knowledge } from "entities/knowledge/types";
import { KnowledgeType } from "entities/knowledge/types";

type KnowledgeListItemProps = {
  isFirstLocked?: boolean;
  isLocked?: boolean;
  isSelected?: boolean;
  knowledge: Knowledge;
  link: string;
  onClick?: () => void;
  shareLink: string;
  trackPage: TrackPage;
  type?: ListItemType;
  withoutWrapper?: boolean;
};

export const KnowledgeListItem = memo(
  ({
    isFirstLocked,
    isLocked = false,
    isSelected,
    knowledge,
    trackPage,
    withoutWrapper,
    ...props
  }: KnowledgeListItemProps) => {
    let item = null;
    if (knowledge.knowledgeType === KnowledgeType.video) {
      item = <ArticleItem {...props} knowledge={knowledge} isVideo />;
    } else if (knowledge.interactive_link) {
      item = (
        <KnowledgeDataNavigationItemBrowseView
          title={knowledge.title}
          imageUrl={knowledge.images?.thumbnail}
          source={knowledge.source}
          timestamp={knowledge.time}
          detailLink={props.link}
        />
      );
    } else {
      item = <ArticleItem {...props} knowledge={knowledge} />;
    }
    if (withoutWrapper) {
      return item;
    }
    return (
      <ListItemWrapper isLocked={isLocked} trackPage={trackPage} isFirstLocked={isFirstLocked} isSelected={isSelected}>
        {item}
      </ListItemWrapper>
    );
  },
);

KnowledgeListItem.displayName = "KnowledgeListItem";
